import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppRoutes } from './routes'
import { Toaster, toast } from 'react-hot-toast'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TOAST_OPTIONS, TOAST_POSITION, TOAST_REVERSE_ORDER } from './constants/toaster'
import config from './constants/global'
import { ErrorBoundary } from '@sentry/react'
import NavigationInjector from './components/layout/NavigationInjector'
import QueryKeyInvalidator from './components/layout/QueryKeyInvalidator'
import { AuthProvider } from './contexts/providers/AuthProvider'
import { HistoryProvider } from './contexts/providers/HistoryProvider'
import SeoHelmet from './components/common/SeoHelmet'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: (error) => {
        const message =
          error?.response?.data?.message || error.message || 'An unexpected error occurred'
        toast.error(message)
      },
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

export const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <QueryKeyInvalidator />
        <BrowserRouter>
          <AuthProvider>
            <HistoryProvider>
              <NavigationInjector />
              <SeoHelmet
                title="Buy Wholesale & Retail Products from Eastleigh"
                description="Shop quality wholesale and retail products from Eastleigh's top retailers and wholesalers on Sokooni.com. Discover great deals, connect directly with sellers, and enjoy fast delivery across Kenya."
                keywords="Eastleigh wholesalers, Eastleigh retailers, Sokooni, sokooni.com, buy from Eastleigh, Kenya marketplace, wholesale marketplace Kenya, retail marketplace Kenya, Eastleigh shopping, online wholesale Kenya, Kenyan ecommerce platform, connect with retailers Kenya, Eastleigh deals"
                url="/"
              />
              <AppRoutes />
              <Toaster
                position={TOAST_POSITION}
                reverseOrder={TOAST_REVERSE_ORDER}
                toastOptions={TOAST_OPTIONS}
              />
            </HistoryProvider>
          </AuthProvider>
        </BrowserRouter>
        {!config.inProduction && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
